import Vue from 'vue';
import VueRouter from 'vue-router';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Authorized from './Authorized';
import store from './store';
import router from './routes';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import Sheet from './components/Sheet';
import './set';
import i18n from './i18n';
import VueGoogleCharts from 'vue-google-charts';
import './dialogDrag.js';

Vue.config.productionTip = false;
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(Viewer);
Viewer.setDefaults({
  zIndexInline: 2017
});
Vue.use(VueGoogleCharts)

Vue.use(VueRouter);
Vue.component("Sheet", Sheet);

Vue.config.errorHandler = (err, vm, info) =>{
  console.error(err);
  console.error(vm);
  console.error(info);
};

new Vue({
  render: h => h(Authorized),
  router,
  store,
  i18n
}).$mount('#app');
